import {useState, useEffect} from 'react';
import {useOktaAuth} from '@okta/okta-react';
import config from '../../oktaConfig';

function useSiteInfo() {
  const {authState, oktaAuth} = useOktaAuth();
  const [siteInfoData, setSiteInfoData] = useState(null);
  const [pending, setPending] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  //#region useEffect
  useEffect(() => {
    const fetchSiteInfo = async (accessToken: string) => {
      try {
        setPending(true);
        const response = await fetch(`${config.resourceServer.insightsApiUrlMinimumSiteInfo}`, {
          mode: 'cors',
          credentials: 'include',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        });
        if (!response.ok) {
          setPending(false);
          setError('Network response was not ok');
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        setSiteInfoData(data);
        setPending(false);
      } catch (error) {
        setPending(false);
        console.error('Failed to fetch site info:', error);
      }
    };

    if (authState && authState.isAuthenticated) {
      const accessToken = oktaAuth.getAccessToken();
      if (accessToken) {
        fetchSiteInfo(accessToken);
      } else {
        setError('Access token is undefined');
        console.error('Access token is undefined');
      }
    }
  }, [oktaAuth, authState]);
  //#endRegion useEffect

  return {siteInfoData, pending, error};
}

export default useSiteInfo;
